import indonesiaMessages from "ra-language-indonesian-new";
const id = {
  ra: {
    ...indonesiaMessages.ra,
    ...indonesiaMessages.ra.notification,
    action: {
      ...indonesiaMessages.ra.action,
      clear_array_input: "Kosongkan list",
      select_columns: "Kolom",
    },
    message: {
      ...indonesiaMessages.ra.message,
      clear_array_input: "Apakah anda yakin ingin membersihkan seluruh list?",
    },
  },
  
  resources: {
    company: {
      name: "Perusahaan",
    },
    sale_return: {
      name: "Retur Penjualan",
    },
    sale_order: {
      name: "Pesan Penjualan",
    },
    purchase_return: {
      name: "Retur Pembelian",
    },
    purchase_order: {
      name: "Pesanan Pembelian",
    },
    user: {
      name: "Pengguna",
    },
    chart_of_account: {
      name: "Chart of Account",
    },
    sales_area: {
      name: "Area Jual",
    },
    customer_type: {
      name: "Tipe Pelanggan",
    },
    supplier: {
      name: "Supplier",
    },
    brand: {
      name: "Merek",
    },
    size: {
      name: "Ukuran",
    },
    category: {
      name: "Kategori",
    },
    kind: {
      name: "Jenis",
    },
    density: {
      name: "Kecerahan",
    },
    color: {
      name: "Warna",
    },
    quality: {
      name: "Kualitas",
    },
    product: {
      name: "Produk",
    },
    warehouse: {
      name: "Gudang",
    },
    transport: {
      name: "Angkutan",
    },
    order: {
      name: "Pesan",
      fields: {
        code: "Kode",
        date: "Tanggal",
        color: "Color",
      },
    },
    sale: {
      name: "Penjualan",
      fields: {
        code: "Kode",
        date: "Tanggal",
        color: "Color",
      },
    },
    purchase: {
      name: "Pembelian",
      fields: {
        code: "Kode",
        date: "Tanggal",
        color: "Color",
      },
    },
    return: {
      name: "Retur",
      fields: {
        code: "Kode",
        date: "Tanggal",
        color: "Color",
      },
    },
    ranking: {
      name: "Ranking",
    },
    customer: {
      name: "Pelanggan",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        dob: "Date of birth",
      },
    },
    price: {
      name: "Harga",
    },
    price_limit: {
      name: "Batas Harga",
      fields: {
        customer_type: "Jenis pelanggan",
        price: "Batas harga",
        note: "Keterangan",
      },
    },
    brand_price_addition: {
      name: "Harga Brand",
    },
    size_price_addition: {
      name: "Harga Ukuran",
    },
    debt_payment: {
      name: "Bayar",
    },
    debt_correction: {
      name: "Koreksi",
    },
    check_cashing: {
      name: "Pencairan Cek/Giro",
    },
    journal: {
      name: "Jurnal",
    },
    inventory_pending: {
      name: "Inventory Pending",
    },
    salesman_incentives: {
      name: "Insentif Salesman",
    },
    salesman_journals: {
      name: "Salesman Jurnal",
    },
    salesman_penalty_details: {
      name: "Detail Pinalti Salesman",
    },
    close_book: {
      name: "Tutup Buku",
    },
    bad_debt: {
      name: "Bad Debt",
    },
    bad_debt_installment: {
      name: "Cicilan",
    },
    bad_debt_correction: {
      name: "Koreksi",
    },
    bad_debt_check_cashing: {
      name: "Cair Giro",
    },
    mutation_repacking: {
      name: "Packing Ulang",
    },
    mutation_inventory_write_off: {
      name: "Pemusnahan",
    },
    mutation_change_goods_code: {
      name: "Ganti Kode Barang",
    },
    mutation_change_location: {
      name: "Pindah Antar Lokasi",
    },
    balance_sheets: {
      name: "Balance Sheets",
    },
    balance_sheet: {
      name: "Balance Sheets",
    },
    income_statement: {
      name: "Income Statements",
    },
    income_statements: {
      name: "Income Statements",
    },
    cost_of_goods_sold: {
      name: "Harga Pokok Produksi",
    },
    cost_of_goods_solds: {
      name: "Harga Pokok Produksi",
    },
    general_ledgers: {
      name: "Buku Besar",
    },
    general_ledger: {
      name: "Buku Besar",
    },
    analysis: {
      name: "Analisis",
    },
    account_receivables: {
      name: "Piutang",
    },
    account_receivable_payments: {
      name: "Bayar",
    },
    account_receivable_corrections: {
      name: "Koreksi",
    },
    account_receivable_cards: {
      name: "Kartu",
    },
    account_receivable_agings: {
      name: "Umur",
    },
    account_receivable_histories: {
      name: "History",
    },
    account_receivable_pcms: {
      name: "+ PCM",
    },
    account_receivable_pcm_cards: {
      name: "Kartu PCM",
    },
    account_receivable_pcm_ages: {
      name: "Umur PCM",
    },
    account_receivable_pcm_overviews: {
      name: "+ PCM Overview",
    },
    account_receivable_pcm_overview: {
      name: "+ PCM Overview",
    },
    account_receivable_bad_debt_histories: {
      name: "History Bad Debt",
    },
    account_receivable_bad_debt_history: {
      name: "History Bad Debt",
    },
    coa: {
      name: "COA",
    },
    role: {
      name: "Peran",
    },
    permission: {
      name: "Permissions",
    },
    customer_list: {
      name: "Daftar Pelanggan",
    },
    customer_membership: {
      name: "Keanggotaan",
    },
    received_check: {
      name: "Terima Giro",
    },
    cashed_returned_check: {
      name: "Cair/Batal Giro",
    },
    inventory_repacking: {
      name: "Packing Ulang",
    },
    inventory_write_off: {
      name: "Musnah Inventory",
    },
    salesman_incentive: {
      name: "Insentif Salesman",
    },
    salesman_journal: {
      name: "Journal Salesman",
    },
    transaction_history: {
      name: "Histori Nomor Bukti",
    },
    coa: {
      name: "COA",
    },
    account_payables: {
      name: "Hutang",
    },
    promotion: {
      name: "Promosi",
    },
    salesmen: {
      name: "Salesmen",
    },
    salesman_target: {
      name: "Salesmen Target",
    },
    setting: {
      name: "Pengaturan",
    },
    account_payable_cards: {
      name: "Kartu",
    },
    account_payable_ages: {
      name: "Umur",
    },
    account_payable_histories: {
      name: "History",
    },
    account_payable_payments: {
      name: "Bayar",
    },
    account_payable_payment: {
      name: "Bayar Hutang",
    },
    account_payable_corrections: {
      name: "Koreksi",
    },
    account_payable_correction: {
      name: "Koreksi Hutang",
    },
    inventories: {
      name: "Inventory",
    },
    inventory_cards: {
      name: "Kartu",
    },
    inventory_ages: {
      name: "Umur",
    },
    inventory_histories: {
      name: "History",
    },
    inventory_repackings: {
      name: "Packing Ulang",
    },
    inventory_write_offs: {
      name: "Musnah",
    },
    product_rankings: {
      name: "Ranking Produk",
    },
    transaction_histories: {
      name: "Histori Nomer Bukti",
    },
    print_histories: {
      name: "Histori Cetak",
    },
    customer_lists: {
      name: "List",
    },
    customer_rankings: {
      name: "Ranking",
    },
    customer_memberships: {
      name: "Membership",
    },
    all_transaction_journals: {
      name: "Semua Jurnal",
    },
    all_transaction_journal: {
      name: "Semua Jurnal",
    },
    journal_memorials: {
      name: "Jurnal Memorial",
    },
    journal_memorial: {
      name: "Jurnal Memorial",
    },
    activity: {
      name: "Aktifitas",
    },
    customer_debt_max_days: {
      name: "Maksimal Hari Piutang",
    },
    settings: {
      name: "Pengaturan",
    },
    restock_plan: {
      name: "Rencana Stok Ulang",
    },

    factory_debt_payment: {
      name: "Bayar Hutang",
    },

    factory_debt_correction: {
      name: "Koreksi Hutang",
    },
    
    customer_debt_payment: {
      name: "Bayar Piutang",
    },

    customer_debt_correction: {
      name: "Koreksi Piutang",
    },

    purchase_net_card: {
      name: "Pembelian Bersih",
    },

    purchase_return_cards: {
      name: "Pembelian Retur",
    },

    purchase_return_card: {
      name: "Pembelian Retur",
    },

    purchase_card: {
      name: "Pembelian Kotor",
    },

    purchase_goods_in_transit: {
      name: "Pembelian Barang dalam Transit",
    },

    sale_net_card: {
      name: "Penjualan Bersih",
    },

    sale_card: {
      name: "Penjualan Kotor",
    },

    sale_ranking: {
      name: "Ranking Penjualan",
    },

    sale_return_cards: {
      name: "Penjualan Retur",
    },

    sale_return_card: {
      name: "Penjualan Retur",
    },

    account_receivable_payment: {
      name: "Bayar Piutang"
    },
    account_receivable_correction: {
      name: "Koreksi Piutang"
    },
    account_receivable_card: {
      name: "Kartu Piutang"
    },
    account_receivable_aging: {
      name: "Umur Piutang"
    },
    account_receivable_history: {
      name: "Historis Pembayaran Piutang"
    },
    account_receivable_pcm: {
      name: "Kartu Piutang + PCM"
    },
    account_receivable_pcm_card: {
      name: "Kartu PCM"
    },
    account_receivable_pcm_age: {
      name: "Umur PCM"
    },
    account_payable_card: {
      name: "Kartu Hutang"
    },
    account_payable_age: {
      name: "Umur Hutang"
    },
    account_payable_history: {
      name: "Historis Hutang"
    },
    inventory_card: {
      name: "Kartu Inventory"
    },
    inventory_age: {
      name: "Umur Inventory"
    },
    inventory_history: {
      name: "Historis Inventory"
    },
    product_ranking: {
      name: "Ranking Produk"
    },
    customer_ranking: {
      name: "Ranking Customer"
    }

    
    
  },
  server: {
    not_allowed: "Tidak Diperbolehkan",
    does_not_match_code_symbol:
      "Jenis yang dipilih tidak sesuai simbol di dalam Kode",
    sale_id_belongs_to_customer_id:
      "Kode jual bukan milik pelanggan yang dipilih",
    is_zero_has_non_zero:
      "Jumlah retur 0 hanya untuk salah satu SJ, utama atau gratis, keduanya harus di sertakan",
    is_main_n_free_exist:
      "Sertakan SJ lainnya, baik itu SJ utama atau SJ gratis keduanya harus ada",
    cannot_cancel_pending: "Tidak bisa membatalkan item yang tertahan ini",
    forbidden_duplication: "Tidak boleh ada pengulangan",
    match_product_code_price_on_a_date:
      "Harga tidak sesuai dengan kode produk dan tanggal yang dipilih",
    is_purchase_date_equal_or_less_than_purchase_return_date:
      "PJ belum tersedia di tanggal yang dipilih",
    less_equal_remaining_stock: "Stok tidak cukup",
    less_equal_purchased_quantity:
      "Total yang telah diretur melebihi yang diterima",
    less_equal_total_purchase_order:
      "Total yang diterima melebihi jumlah yang diorder",
    equal_greater_than_item_date: "Tidak boleh kurang dari tanggal pesan",
    unapproved_previous_sale_not_exist: "Approve SJ sebelumnya terlebih dahulu",
    unique_start_date_for_quality_filter_by:
      "Duplikat tanggal mulai pada salah satu kualitas (KW)",
    current_month_must_be_greater: "Hanya bisa tutup bulan yang telah lewat",
    calculated_but_not_closed_yet: "Aneh, telah dihitung tapi belum tutup buku", // tiap akun sdh di hitung saldonya di monthly balance, tp status table close_books belum tutup
    is_book_open: "Periode ini sudah tutup buku",
    is_allowed_to_be_parent: "Akun ini sudah pernah dijurnal sebagai anak",
    date_is_not_greater: "Cek tanggal, saat itu transaksi ini belum ada",
    date_is_not_in_future: "Tanggal cut-off tidak boleh melebihi hari ini",
    close_previous_month_first: "Tutup periode sebelumnya terlebih dahulu",
    is_debit_equal_credit: "Total debit harus sama dengan total kredit",
    less_equal_with_order_quantity_db:
      "Harus kurang atau sama dengan sisa jumlah pesanan",
    either_debit_or_credit_is_zero:
      "Debit dan kredit, keduanya tidak boleh nol",
    cannot_use_parent_for_journal: "Akun induk tidak bisa digunakan menjurnal",
    is_unapproved: "Ini belum disetujui",
    need_exactly_three_files: "Butuh tiga file",
    approved_this_transaction_first: "Setujui transaksi ini dulu: %{code}",
    open_next_month_first: "Buka periode setelahnya dulu",
    is_coa_a_child: "Jangan gunakan induk, pilihlah COA anak",
    has_active_price: "Tidak ada harga untuk tanggal yang dipilih",
    must_be_of_same_group: "Produk harus dari jenis group yang sama",
    must_be_of_same_supplier:
      "Semua produk harus dari supplier yang sama (penting untuk umur piutang berdasarkan supplier)",
    notes_receivable_for_giro: "Notes receivable untuk pembayaran tipe giro",
    belongs_to_other_supplier: "Produk ini pernah dibeli dari supplier lain",
    no_unapproved_rj: "Ada RJ yang belum di setujui",
    no_unapproved_kp: "Ada KP yang belum di setujui",
    no_unapproved_arp: "Ada ARP yang belum di setujui",
    no_unapproved_cas: "Ada CAS yang belum di setujui",
    no_unapproved_bdk: "Ada BDK yang belum di setujui",
    no_unapproved_bdp: "Ada BDP yang belum di setujui",
    no_unapproved_cbd: "Ada CBD yang belum di setujui",
    no_uncashing_check: "Ada ARP giro yang belum di cairkan",
    required_if_repeat_print: "Alasan wajib diisi",
    each_user_allowed_once: "Tiap user hanya boleh print invoice satu kali",
    mix_return: "Subtotal item RJ melebihi piutang SJ",
    is_book_closed: "Periode ini belum tutup buku",
    sort_required: "Parameter sort tidak boleh kosong",
    administrator_can_exceeds_50_million:
      "Hubungi administrator/superadmin untuk setting lebih dari 50 juta",
    must_be_the_same_temporary:
      "Karna jurnalnya belum disesuaikan, sementara ini, bonus harus sama dengan produk utama",
    sale_date_change_limit: "Perubahan tanggal melebihi limit yang dibolehkan",
  },
  mine: {
    filter: {
      search_all: "Cari semua",
    },
    document_type: {
      invoice: "Invoice",
      delivery_note: "Surat Jalan",
      purchase: "Pembelian",
      sale_return: "Retur Penjualan",
      purchase_return: "Retur Pembelian",
    },
    expand_menu: {
      purchase: "Pembelian",
      sale: "Penjualan",
      order: "Pesan",
      product_code: "Kode Produk",
      factory_debt: "Hutang",
      customer_debt: "Piutang",
      bad_debt: "Bad Debt",
      mutation: "Mutasi",
      report: "Laporan",
      general_ledger: "General Ledger",
      analysis: "Analisis",
      account_receivables: "Piutang",
      account_payables: "Hutang",
      inventories: "Inventory",
      payment_check: "Giro",
    },
    message: {
      approve: "Setujui",
      unapprove: "Batal Setujui",
      cancel: "Batalkan",
      close_book: "Tutup Buku",
      open_book: "Buka Buku",
      approve_content: "Apakah anda yakin ingin menyetujui data ini?",
      unapprove_content: "Apakah anda yakin ingin batal menyetujui data ini?",
      cancel_content: "Apakah anda yakin ingin membatalkan data ini?",
      close_book_content: "Apakah anda yakin ingin menutup periode ini?",
      open_book_content: "Apakah anda yakin ingin membuka periode ini?",
      transport_according_to: "Isi berdasarkan jumlah mobil atau jumlah kg",
      divider_value: "Pembagi quantity (1.05, 1.1 atau 1.15)",
      // over_due_debt:
      //   "Hanya untuk penjualan yg belum lunas, kecuali pelanggan punya hutang melebihi batas waktu",
      print_again:
        "Data ini sudah pernah dicetak %{count} kali, ketik alasan anda kenapa ingin cetak lagi",
      print_count: "Data ini sudah pernah dicetak %{count} kali",
      print_content: "Apakah anda yakin ingin cetak data ini?",
      export_content: "Apakah anda yakin ingin export data ini?",
      delete_purchase_order_content:
        "Apakah anda yakin ingin menghapus pesanan pembelian ini? Jika sudah dipakai transaksi pembelian, penghapusan akan ditolak.",
    },
    dialog: {
      create_sale_order: "Buat Pesanan Penjualan",
      edit_sale_order: "Ubah Pesanan Penjualan",
      create_sale: "Buat Penjualan",
      edit_sale: "Ubah Penjualan",
      create_sale_return: "Buat Retur Penjualan",
      edit_sale_return: "Ubah Retur Penjualan",
      create_promotion: "Buat Promosi",
      edit_promotion: "Ubah Promosi",
      create_factory_debt_payment: "Buat Pembayaran Hutang",
      edit_factory_debt_payment: "Ubah Pembayaran Hutang",
      create_factory_debt_correction: "Buat Koreksi Hutang",
      edit_factory_debt_correction: "Ubah Koreksi Hutang",
      create_customer_debt_payment: "Buat Pembayaran Piutang Pelanggan",
      edit_customer_debt_payment: "Ubah Pembayaran Piutang Pelanggan",
      create_customer_debt_correction: "Buat Koreksi Piutang Pelanggan",
      edit_customer_debt_correction: "Ubah Koreksi Piutang Pelanggan",
      create_check_cashing: "Buat Pencairan Cek/Giro",
      edit_check_cashing: "Ubah Pencairan Cek/Giro",
      create_journal: "Buat Jurnal",
      edit_journal: "Ubah Jurnal",
      create_bad_debt: "Buat Piutang Macet",
      edit_bad_debt: "Ubah Piutang Macet",
      create_product: "Buat Produk",
      edit_product: "Ubah Produk",
      create_bad_debt_installment: "Buat Cicilan Piutang Macet",
      edit_bad_debt_installment: "Ubah Cicilan Piutang Macet",
      create_bad_debt_correction: "Buat Koreksi Piutang Macet",
      edit_bad_debt_correction: "Ubah Koreksi Piutang Macet",
      create_bad_debt_check_cashing: "Buat Pencairan Cek/Giro Piutang Macet",
      edit_bad_debt_check_cashing: "Ubah Pencairan Cek/Giro Piutang Macet",
      create_purchase_order: "Buat Pesan Pembelian",
      edit_purchase_order: "Ubah Pesan Pembelian",
      create_mutation_repacking: "Buat Packing Ulang",
      edit_mutation_repacking: "Ubah Packing Ulang",
      create_mutation_inventory_write_off: "Buat Pemusnahan Barang",
      edit_mutation_inventory_write_off: "Ubah Pemusnahan Barang",
      print_delivery_note: "Cetak Surat Jalan",
      print: "Cetak",
      create_price: "Buat Harga",
      edit_price: "Ubah Harga",
      create_transport: "Buat Transport",
      edit_transport: "Ubah Transport",
      create_kind: "Buat Jenis",
      edit_kind: "Ubah Jenis",
      create_customer_debt_max_day: "Buat Maksimal Hari Piutang",
      edit_customer_debt_max_day: "Ubah Maksimal Hari Piutang",
      create_brand_price_addition: "Buat Harga Brand",
      edit_brand_price_addition: "Ubah Harga Brand",
      create_size_price_addition: "Buat Harga Ukuran",
      edit_size_price_addition: "Ubah Harga Ukuran",
      create_category: "Buat Kategori",
      edit_category: "Ubah Kategori",
      create_setting: "Buat Pengaturan",
      edit_setting: "Ubah Pengaturan",
      delete_purchase_order: "Hapus Pesanan Pembelian",
    },
    notification: {
      "403_error": "Tidak dapat mengubah data yang telah disetujui",
      not_allowed: "Tidak Diperbolehkan",
      Not_Found: "Tidak ditemukan",
      Free_package_is_unedited:
        "SJ gratis tidak bisa diubah, coba ubah SJ utamanya",
      cannot_delete_used_data:
        "Pesanan pembelian ini sudah dipakai transaksi pembelian, jadi tidak bisa dihapus",
      Internal_server_error: "Kesalahan internal server",
    },
    label: {
      account: "Akun",
      amount: "Nominal",
      code: "Kode",
      receipt_no: "No. Bukti",
      receipt_no_sj: "No. Bukti SJ",
      receipt_no_pcm: "No. Bukti PCM",
      company: "Perusahaan",
      depo: "Depo",
      correction: "Koreksi",
      customer: "Pelanggan",
      credit: "Kredit",
      create: "Buat",
      date: "Tanggal",
      debt: "Hutang",
      edit: "Ubah",
      cancel: "Pembatalan",
      cashing: "Pencairan",
      check_number: "No. Cek / Giro",
      coa_code: "Kode COA",
      customer_debt: "Piutang",
      customer_debts: "Daftar Piutang",
      debit: "Debit",
      discount_per_box: "Diskon / box",
      due_date: "Tanggal jatuh tempo",
      end_date: "Tanggal berakhir",
      end_code: "Kode akhir",
      journal: "Jurnal",
      name: "Nama",
      note: "Keterangan",
      order_quantity: "Jumlah pesanan",
      package: "Paket",
      persentage: "Persentase",
      percentage_in_decimal: "Persentase dalam desimal",
      price_per_box: "Harga / box",
      product_code: "Kode produk",
      product_code_bonus: "Kode produk bonus",
      promotions: "Promosi",
      promotion: "Promosi",
      purchase_order: "Pesanan Pembelian",
      purchase_number: "Nomer beli",
      received_quantity: "Jumlah diterima",
      not_received_quantity: "Jumlah belum diterima",
      rejected: "Penolakan",
      sales_number: "Nomer penjualan",
      sent_quantity: "Jumlah kirim",
      special_discount_per_box: "Spesial diskon / box",
      start_date: "Tanggal mulai",
      start_code: "Kode awal",
      total_correction: "Jumlah koreksi",
      total_vehicle: "Jumlah angkutan",
      transaction_date: "Tanggal transaksi",
      transport: "Angkutan",
      type: "Tipe",
      settled: "Lunas",
      unsettled: "Belum Lunas",
      sale_code: "Kode jual",
      sale_item: "Item jual",
      warehouse: "Gudang",
      return_quantity: "Jumlah retur",
      price: "Harga",
      total: "Total",
      bad_debt: "Piutang Macet",
      installment: "Cicilan",
      payment: "Pembayaran",
      remaining_debt: "Sisa Hutang",
      remaining_stock: "Sisa Stok",
      remain: "Sisa",
      total_payment: "Total Bayar",
      supplier: "Supplier",
      max_payment_days: "Max Hari Pembayaran",
      quality: "Kualitas",
      quantity: "Jumlah",
      stocktake: "Opname",
      sample: "Sampel",
      ref_number: "Nomer Surat Jalan",
      cogs: "HPP",
      kind: "Jenis",
      active: "Aktif",
      operator_name: "Nama Operator",
      warehouse_broke: "Pecah Gudang",
      transfer_between_depo: "Mutasi Antar Depo",
      warning: "Peringatan",
      reason: "Alasan",
      document_type: "Jenis Dokumen",
      cus_sup: "Pelanggan/Supplier",
      brand: "Merek",
      size: "Ukuran",
      motif: "Motif",
      density: "Kecerahan",
      color: "Warna",
      buy_price: "Harga Beli",
      sell_price: "Harga Jual",
      transport_discount: "Diskon Angkutan / box",
      cost: "Harga",
      cost_type: "Tipe Harga",
      capacity: "Kapasitas",
      plate: "Plat",
      plate_number: "Plat Nomer",
      sale_order: "Pesan Penjualan",
      balance: "Balance",
      return: "Retur",
      ranking: "Ranking",
      sent: "Kirim",
      previous: "Sebelumnya",
      report: "Laporan",
      transaction: "Transaksi",
      general_ledger_detail: "Detail Buku Besar",
      show_detail: "Detail",
      current_balance: "Akhir",
      income_statement: "Income Statement",
      balance_sheet: "Balance Sheet",
      tax: "Pajak",
      percentage: "Persentase",
      permission: "Permission",
      role: "Role",
      symbol: "Simbol",
      "13_chars": "13 karakter",
      "10_chars": "10 karakter contoh: G40SPW=LCR",
      loan_limit: "Limit Piutang",
      loan_tenor: "Pelunasan (Hari)",
      loan_tenor_tolerance: "Toleransi (Hari)",
      pic: "Penanggung Jawab",
      address: "Alamat",
      closed: "Telah Tutup",
      month: "Bulan",
      year: "Tahun",
      period: "Periode",
      closed_date: "Tanggal Tutup",
      open: "Buka",
      close: "Tutup",
      nature: "Normal",
      class: "Kelas",
      parent: "Induk",
      delivery_note: "Nomer Ref.",
      order_no: "No. Pesan",
      created_at: "Dibuat Pada",
      join_on: "Bergabung Pada",
      customer_code: "Kode Pelanggan",
      customer_name: "Nama Pelanggan",
      supplier_code: "Kode Supplier",
      supplier_name: "Nama Supplier",
      initial_balance: "Saldo Awal",
      final_balance: "Saldo Akhir",
      total_day: "Total Hari",
      dashboard_title: "👋 Selamat datang di Acura Nexus",
      dashboard_subtitle:
        "Ini adalah generasi kedua dari Acura, sebuah aplikasi akunting yang dibuat oleh CJFI untuk Depo-Deponya (cabang). Hubungi Divisi Depo Support jika kamu membutuhkan pendampingan atau hubungi Divisi IT jika kamu menemukan masalah teknis. 😁",
      dashboard_contact_dp_support: "Hubungi Depo Support",
      dashboard_contact_it: "Hubungi IT",
      upload: "Unggah",
      sales_area_first: "Pastikan menu area jual sudah terisi",
      upload_two_file_customer_and_address:
        "Upload dua file sekaligus (pelanggan dan alamat pelanggan)",
      upload_two_file_transport_and_its_detail:
        "Upload dua file sekaligus (angkutan dan detailnya)",
      upload_two_files: "Upload dua file sekaligus",
      upload_three_files: "Upload tiga file sekaligus",
      initial: "Awal",
      other: "Lainnya",
      final: "Akhir",
      according_to_cogs: "Berdasarkan HPP",
      value_in: "Nilai Masuk",
      value_out: "Nilai Keluar",
      other_value: "Nilai Lain",
      initial_value: "Nilai Awal",
      final_value: "Nilai Akhir",
      net: "Bersih",
      gross: "Kotor",
      value: "Nilai",
      box: "Boks",
      due: "Jatuh Tempo",
      gross_purchase: "Pembelian Kotor",
      gross_sale: "Penjualan Kotor",
      net_purchase: "Pembelian Bersih",
      net_sale: "Penjualan Bersih",
      goods_code: "Kode Barang",
      day: "Hari",
      age: "Umur",
      approve: "Setujui",
      unapprove: "Batal Setujui",
      account_receivable_net: "Piutang Bersih",
      received_date: "Tanggal Terima",
      print_invoice: "Cetak Invoice",
      payment_code: "Kode Bayar",
      effective_date: "Tanggal Efektif",
      sale_date: "Tanggal Jual",
      sale_price: "Harga Jual",
      profit_average: "Rata-Rata Profit",
      average_sales: "Rata-Rata Penjualan",
      select: "Pilih",
      effective_month: "Bulan Efektif",
      cut_off_date: "Tanggal Cut Off",
      goods_in_transit: "Barang dlm Perjalanan",
      divider: "Pembagi",
      day_range: "Range Hari",
      change_password: "Ganti Password",
      dynamic_code: "Kode Dinamis",
      check: "Giro",
      approved: "Disetujui",
      description: "Deskripsi",
      check_cashing_date: "Tanggal Pencairan",
      bank_name: "Nama Bank",
      actions: "Aksi",
      coa: "Akun",
      coa_name: "Nama Akun",
      customer_debt_payment_code: "Kode Bayar Piutang",
      bad_debt_installment_code: "Kode Cicil Piutang",
      product_name: "Nama Produk",
      sent_qty: "Jumlah Kirim",
      return_qty: "Jumlah Retur",
      product: "Produk",
      kind: "Jenis",
      stock: "Stok",
      location: "Lokasi",
      total_in: "Masuk",
      total_out: "Keluar",
      product: "Produk",
      category: "Kategori",
      unit: "Satuan",
      destination: "Tujuan",
      phone: "Telpon",
      create_new_item: "BUAT BARU",
      change_company: "Ganti Depo",
      browser_not_supported:
        "Maaf, browser yang kamu gunakan saat ini tidak didukung. Untuk pengalaman terbaik, mohon gunakan Chrome Browser untuk akses aplikasi ini.",
      setting: "Pengaturan",
      total_day_bad_debt: "Maksimal Hari Piutang",
      last_period_sale_ranking: "Periode Ranking",
      main_product: "Produk Utama",
      product_bonus: "Produk Bonus",
      order: "Pesan",
      created_by: "Dibuat Oleh",
      received: "Terima",
      cashed_returned: "Cair / Batal",
      received_check: "Terima Giro",
      cashed_returned_check: "Cair / Batal Giro",
      cost_of_goods_sold: "Harga Pokok Produksi",
      bad_debt_history: "History Bad Debt",
      payment_period: "Hari Bayar",
      city: "Kota",
      postal_code: "Kode Pos",
      transaction_history: "Histori Nomer Bukti",
      transaction_code: "Kode Transaksi",
      account_receivable_pcm_overview: "AR + PCM Overview",
      salesman_incentive: "Insentif Salesman",
      salesman_journal: "Jurnal Salesman",
      salesman_penalty_detail: "Detail Pinalti Salesman",
      salesman: "Salesman",
    },
    radio_btn: {
      return_warehouse: "Masuk Gudang",
      return_broken: "Tidak Masuk Gudang / Rusak",
    },
    list_title: {
      factory_debt_payment: "Bayar Hutang",
      factory_debt_correction: "Koreksi Hutang",
      customer_debt_payment: "Bayar Piutang",
      customer_debt_correction: "Koreksi Piutang",
      purchase_order: "Pesanan Pembelian",
      purchase_return: "Retur Pembelian",
      sale_order: "Pesan Penjualan",
      sale_return: "Retur Penjualan",
      sale_ranking: "Ranking Penjualan",
      check_cashing: "Pencairan Cek/Giro",
      journal: "Jurnal",
      bad_debt: "Piutang Macet",
      bad_debt_installment: "Cicilan Piutang Macet",
      bad_debt_correction: "Koreksi Piutang Macet",
      bad_debt_check_cashing: "Pencairan Cek/Giro Piutang Macet",
      mutation_repacking: "Packing Ulang",
      mutation_inventory_write_off: "Pemusnahan Barang",
      all_transaction_journal: "Semua Jurnal Transaksi",
      general_ledger: "Buku Besar",
      inventory_pending: "Stok Tertahan",
      account_receivable_payment: "Bayar Piutang",
      account_receivable_correction: "Koreksi Piutang",
      account_receivable_card: "Kartu Piutang",
      account_receivable_aging: "Umur Piutang",
      account_receivable_history: "Historis Pembayaran Piutang",
      account_receivable_pcm: "Kartu Piutang + PCM",
      account_receivable_pcm_card: "Kartu PCM",
      account_receivable_pcm_age: "Umur PCM",
      account_payable_card: "Kartu Hutang",
      account_payable_age: "Umur Hutang",
      account_payable_history: "Historis Hutang",
      inventory_card: "Kartu Inventory",
      inventory_age: "Umur Inventory",
      inventory_history: "Historis Inventory",
      product_ranking: "Ranking Produk",
      customer_ranking: "Ranking Customer",
      restock_plan: "Rencana Stok Ulang",
      journal_memorial: "Jurnal Memorial",
    },
    btn: {
      approve: "Setujui",
    },
    tooltip: {
      total_inventory_write_off: "Nilainya bisa berbeda setelah di approve",
    },
  },
};
export default id;
